// extracted by mini-css-extract-plugin
export default {"imageWrapper":"MC-z","videoWrapper":"NC-z","twoColumnImage":"OC-z","imageCarouselBtn":"PC-z","carouselNextBtn":"QC-z","carouselPrevBtn":"RC-z"};